import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f23273a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page d-full-w d-overflow d-flex-column d-flex-1f d-overflow" }
const _hoisted_2 = { class: "d-flex-1f d-overflow form-wrapper" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text" }, "添加图片", -1))
const _hoisted_4 = { class: "bottom-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!
  const _component_van_area = _resolveComponent("van-area")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_action_sheet = _resolveComponent("van-action-sheet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: _ctx.publicSupplies,
      class: "d-flex-1f d-flex-column",
      "input-align": "right"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_cell_group, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.donateName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.suppliesInfo.donateName) = $event)),
                label: "捐赠人姓名",
                maxlength: "5",
                placeholder: "请填写捐赠人姓名",
                rules: [
                            { required: true, message: '请填写捐赠人姓名' },
                        ]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.phone,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.suppliesInfo.phone) = $event)),
                maxlength: "11",
                label: "联系电话",
                placeholder: "请填写联系电话",
                rules: [
                            { required: true, message: '请填写联系电话' },
                            { validator: _ctx.checkTel, message: _ctx.errPhonemsg },
                        ]
              }, null, 8, ["modelValue", "rules"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.suppliesName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.suppliesInfo.suppliesName) = $event)),
                maxlength: "30",
                label: "物资名字",
                placeholder: "请填写物资名字",
                rules: [{ required: true, message: '请填写物资名字' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.qty,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.suppliesInfo.qty) = $event)),
                maxlength: "30",
                label: "物资数量",
                placeholder: "请填写物资数量",
                type: "digit",
                rules: [{ required: true, message: '请填写物资数量' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.oldAndNew,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.suppliesInfo.oldAndNew) = $event)),
                maxlength: "30",
                readonly: "",
                label: "新旧程度",
                placeholder: "请选择新旧程度",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showOldNewPicker = true)),
                rules: [{ required: true, message: '请选择新旧程度' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.desc,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.suppliesInfo.desc) = $event)),
                label: "物资描述",
                type: "textarea",
                placeholder: "请描述物资信息",
                rules: [{ required: true, message: '请描述物资信息' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.areaFormat,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.suppliesInfo.areaFormat) = $event)),
                label: "选择省市区",
                readonly: "",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPopover = true)),
                "right-icon": " iconfont d-dizhi addr-ico",
                rules: [{ required: true, message: '选择省市区' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.address,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.suppliesInfo.address) = $event)),
                label: "地址",
                maxlength: "300",
                placeholder: "请填写地址",
                rules: [{ required: true, message: '请填写地址' }]
              }, null, 8, ["modelValue"]),
              _createVNode(_component_van_field, {
                modelValue: _ctx.suppliesInfo.suppliesImgs,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.suppliesInfo.suppliesImgs) = $event)),
                label: "附加照片",
                class: "d-flex-column"
              }, {
                input: _withCtx(() => [
                  _createVNode(_component_van_row, { class: "d-full-w img-wrapper" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suppliesInfo.suppliesImgsArray, (item, index) => {
                        return (_openBlock(), _createBlock(_component_van_col, {
                          span: "6",
                          key: item,
                          class: "img-gutter"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_RatioHeightContainer, { ratio: 75 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_image, {
                                  class: "picturer",
                                  alt: "图片加载中...",
                                  width: "100%",
                                  height: "100%",
                                  fit: "cover",
                                  src: _ctx.img(item),
                                  onClick: ($event: any) => (_ctx.previewImage(item))
                                }, null, 8, ["src", "onClick"]),
                                _createVNode(_component_van_icon, {
                                  name: "clear",
                                  onClick: ($event: any) => (_ctx.delImg(index)),
                                  class: "del-img"
                                }, null, 8, ["onClick"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _withDirectives(_createVNode(_component_van_col, {
                        span: "6",
                        class: "img-gutter"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "btn-add-img",
                            onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.chooseImage && _ctx.chooseImage(...args)))
                          }, [
                            _createVNode(_component_van_icon, { name: "plus" }),
                            _hoisted_3
                          ])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, 
                                        _ctx.suppliesInfo.suppliesImgsArray.length <
                                        9
                                    ]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_van_button, {
            type: "primary",
            class: "btn",
            "native-type": "submit",
            block: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.btnText), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit"]),
    _createVNode(_component_van_popup, {
      show: _ctx.showPopover,
      "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showPopover) = $event)),
      position: "bottom",
      style: { height: '30%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_area, {
          onConfirm: _ctx.areaConfirm,
          "area-list": _ctx.areaList,
          value: "440106"
        }, null, 8, ["onConfirm", "area-list"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_action_sheet, {
      "close-on-popstate": "",
      onSelect: _ctx.onOldNewConfirm,
      round: false,
      show: _ctx.showOldNewPicker,
      "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.showOldNewPicker) = $event)),
      actions: _ctx.oldNewColumns,
      "cancel-text": "取消",
      "close-on-click-action": "",
      onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showOldNewPicker = false))
    }, null, 8, ["onSelect", "show", "actions"])
  ]))
}